import appGlobalScript from '/builds/infomaniak/front/web-components/packages/module-status/src/common/init.ts';
export const globalScripts = appGlobalScript;
